import { Button, Search, Select } from '@usitsdasdesign/dds-react'
import { useEffect } from 'react';
import InputWithTags from './InputWithTags';

function SelectAndSearch({ searchValueFor, options, searchValue, valueChanged, onSearch, onChange, isSearchWithTag = false,  }) {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    useEffect(() => {
        if (!isSearchWithTag) {
            const input = document.getElementById('filter-search-input')?.querySelector('.DDSSearch__input');
            setTimeout(() => {
                if (input) {
                    input.addEventListener('keydown', handleKeyDown);
                }
            }, 0);
            return () => input.addEventListener('keydown', handleKeyDown);
        }

    }, []);

    return (
        <div className='flex' id='filter-search-input'>
            <Select
                name='filterSearchFor'
                placeholder="All"
                selectItems={options}
                size="m"
                value={searchValueFor}
                valueChanged={onChange}
                className={isSearchWithTag ? '!w-auto' : ''}
                stickerOptions={{
                    maxHeight: 350,
                    isDynamic: true,
                    className: '[&>div]:!w-full [&_.Context-menu]:!w-[288px]'
                }}
            />
            
            {isSearchWithTag ? <InputWithTags
                icon="search__s__stroke"
                className='flex !flex-rows bg-white shadow-xs px-2 min-w-40 md:min-w-60 max-w-[550px]'
                placeholder="Search"
                value={searchValue}
                valueChanged={valueChanged}
                size="m"
                allowFreeText
                isSearchIcon={true}
                isInsideFilter={true}
                chipBgColor={isSearchWithTag ? 'bg-gray-1100' : 'bg-green-900'}
            /> : <Search
                icon="search__s__stroke"
                placeholder="Search"
                size="m"
                value={searchValue}
                valueChanged={valueChanged}
                className='min-w-[200px]'
            />}
            
            <Button
                label='Search'
                onClick={onSearch}
            />
        </div>
    )
}

export default SelectAndSearch;